import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '热门分类',
    links: [
      { label: '网红爆料', path: '/category/wanghong-baoliao' },
      { label: '明星黑料', path: '/category/mingxing-heitiao' },
      { label: '热门追踪', path: '/category/remen-zhuizong' },
      { label: '吃瓜视频', path: '/category/chigua-shipin' },
    ],
  },
  {
    title: '快速导航',
    links: [
      { label: '首页', path: '/' },
      { label: '娱乐圈', path: '/category/yule-quan' },
      { label: '直播圈', path: '/category/zhibo-quan' },
      { label: '关于我们', path: '/about' },
    ],
  },
  {
    title: '关于本站',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '联系我们', path: '/about#contact' },
      { label: '免责声明', path: '/about#disclaimer' },
      { label: '隐私政策', path: '/about#privacy' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-[40%]">
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-heading font-bold text-primary-600 whitespace-nowrap">
                91在线吃瓜
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-md">
              汇集全网最新网红爆料、明星黑料与热门吃瓜资讯。每日更新，追踪不迷路。吃瓜群众首选入口，做最懂你的娱乐资讯平台。
            </p>
            <div className="space-y-3">
              <label className="block text-xs font-medium text-foreground-500">
                订阅每日吃瓜推送
              </label>
              <form
                data-readdy-form="footer-subscribe"
                className="flex flex-col sm:flex-row gap-2"
                onSubmit={(e) => e.preventDefault()}
              >
                <input
                  type="email"
                  name="email"
                  placeholder="输入你的邮箱地址"
                  className="flex-1 px-4 py-2.5 bg-transparent border-b border-foreground-300 text-sm text-foreground-900 placeholder-foreground-400 outline-none focus:border-primary-500 transition-colors"
                />
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="honeypot-field"
                />
                <button
                  type="submit"
                  className="whitespace-nowrap px-6 py-2.5 rounded-lg border border-primary-500 text-primary-600 text-sm font-medium hover:bg-primary-50 transition-colors duration-200 cursor-pointer"
                >
                  订阅
                </button>
              </form>
            </div>
          </div>

          <div className="lg:w-[60%] grid grid-cols-2 sm:grid-cols-3 gap-8">
            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="text-sm font-semibold text-foreground-900 mb-4">
                  {group.title}
                </h4>
                <ul className="space-y-3">
                  {group.links.map((link) => (
                    <li key={link.path}>
                      <Link
                        to={link.path}
                        className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="w-full px-4 md:px-6 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2026 91在线吃瓜网. All rights reserved. 本站内容仅供娱乐参考。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors" rel="nofollow">
                免责声明
              </a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors" rel="nofollow">
                隐私政策
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}